import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";
import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const valorantFetchAgentData = lazyFn(
  () => import("@/game-val/fetch-agent-data.mjs"),
);
const valorantFetchLeaderboardData = lazyFn(
  () => import("@/game-val/fetch-leaderboard-data.mjs"),
);
const valorantFetchStatsData = lazyFn(
  () => import("@/game-val/fetch-stats-data.mjs"),
);
const valorantFetchWeaponData = lazyFn(
  () => import("@/game-val/fetch-weapon-data.mjs"),
);
const valorantFetchPostmatchData = lazyFn(
  () => import("@/game-val/valorant-fetch-postmatch-data.mjs"),
);
const valorantFetchProfileData = lazyFn(
  () => import("@/game-val/valorant-fetch-profile-data.mjs"),
);
const fetchLivePageData = lazyFn(
  () => import("@/game-val/fetch-live-page-data.mjs"),
);
const fetchActReviewData = lazyFn(
  () => import("@/game-val/fetches/act-review-data.mjs"),
);

const fetchLineupsData = lazyFn(
  () => import("@/game-val/fetches/fetch-lineups-data.mjs"),
);

// const fetchPatchNotes = lazyFn(
//   () => import("@/game-val/fetches/patch-notes.mjs"),
// );

const fetchArticle = lazyFn(() => import("@/game-val/fetches/article.mjs"));
const fetchArticles = lazyFn(
  () => import("@/shared/fetch-contentful-articles.mjs"),
);

const profileTabs = ["weapons", "agents", "coaching"].join("|");
export const VAL_LIVE_GAME_PATH = pathRegExp("/valorant/in-game/:nameTag");

const routes: BaseRoute[] = [
  {
    path: pathRegExp(`/valorant/profile/:nameTag{/:tab(${profileTabs})}?`),
    component: "game-val/Profile.jsx",
    fetchData: valorantFetchProfileData,
  },
  {
    path: pathRegExp("/valorant/match/:nameTag/:actId/:matchId"),
    component: "game-val/Postmatch.jsx",
    fetchData: valorantFetchPostmatchData,
    key: "val-postmatch",
  },
  {
    path: "/valorant/leaderboards/official",
    component: "game-val/Leaderboard.tsx",
    fetchData: valorantFetchLeaderboardData,
  },
  {
    path: "/valorant/stats",
    redirect: "/valorant/stats/agents",
  },
  {
    path: pathRegExp("/valorant/stats/(agents|maps|weapons)"),
    component: "game-val/Stats.jsx",
    fetchData: valorantFetchStatsData,
  },
  {
    path: "/valorant/weapons",
    redirect: "/valorant/weapons/classic",
  },
  {
    path: pathRegExp("/valorant/weapons/:weapon"),
    component: "game-val/Weapon.jsx",
    fetchData: valorantFetchWeaponData,
  },
  {
    path: "/valorant/maps",
    redirect: "/valorant/lineups",
  },
  {
    path: "/valorant/maps/:map",
    redirect({ parameters: [map] }, searchParams) {
      searchParams.set("map", map);
      return `/valorant/lineups?${searchParams.toString()}`;
    },
  },
  {
    path: pathRegExp("/valorant/lineups"),
    component: "game-val/Lineups.tsx",
    fetchData: fetchLineupsData,
  },
  {
    path: pathRegExp("/valorant/lineups/:map"),
    redirect({ parameters: [map] }, searchParams) {
      searchParams.set("map", map);
      return `/valorant/lineups?${searchParams.toString()}`;
    },
  },
  {
    path: pathRegExp("/valorant/videos{/:tab}?"),
    redirect: "/valorant/lineups",
  },
  {
    path: pathRegExp("/valorant/agents/:agent"),
    component: "game-val/Agent.tsx",
    fetchData: valorantFetchAgentData,
  },
  {
    path: "/valorant/agents",
    redirect: "/valorant/agents/astra",
  },
  {
    path: VAL_LIVE_GAME_PATH,
    component: "game-val/LiveMatch.jsx",
    fetchData: fetchLivePageData,
  },
  {
    path: "/valorant/act-review",
    component: "game-val/SeasonReviewSearch.tsx",
  },
  {
    path: pathRegExp("/valorant/act-review/:profileId/:actId"),
    component: "game-val/SeasonReview.tsx",
    fetchData: fetchActReviewData,
  },
  // {
  //   path: "/valorant/patch-notes",
  //   component: "game-val/PatchNotes.tsx",
  //   fetchData: fetchPatchNotes,
  // },
  {
    path: pathRegExp("/valorant/article/:id"),
    component: "game-val/Article.tsx",
    fetchData: fetchArticle,
  },
  {
    path: "/valorant/guides",
    component: "game-val/Guides.tsx",
    async fetchData() {
      await fetchArticles(GAME_SYMBOL_VAL);
    },
  },
];

routes.push({
  [catchAllRoutes]: routes,
  async fetchData() {
    const { default: fetchConstants } = await import(
      "@/game-val/fetch-constants-data.mjs"
    );

    return fetchConstants();
  },
});

export default routes;
